import { ErrorMessage } from '../Message';

export default class ServiceMessages extends ErrorMessage {
  constructor(contents, code, response) {
    super(contents);
    this.code = code;
    this.response = response;
  }
}
